"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = DisabledFormSubmit;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DisabledFormSubmit(props, context) {
  return _react2.default.createElement("input", _extends({ type: "submit", disabled: !context.form.isValid() }, props));
}

DisabledFormSubmit.contextTypes = {
  form: _react.PropTypes.object.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./~/react-inform/lib/disabledFormSubmit.js
// module id = 964
// module chunks = 0